export interface Sconto {
    codice: string,
    tipo: number,
    indicatore_percentuale_assoluto: number,
    data_inizio: string,
    data_fine: string,
    valore: number,
    utilizzato: number,
    importo_minimo: number
}

export function isAvailable(sconto : Sconto, subtotal) {
    let importo_minimo = sconto.importo_minimo;

    if (sconto.indicatore_percentuale_assoluto) {
        importo_minimo = Math.max(sconto.importo_minimo, sconto.valore)
    }

    return importo_minimo <= subtotal;
}

export function scontoValoreAssoluto(sconto : Sconto, subtotal) {
    if (sconto.indicatore_percentuale_assoluto)
        return sconto.valore;
    return Number(sconto.valore) / 100 * subtotal;
}